import React from 'react';
import styled from 'styled-components';
import { useNavigation } from '../hooks/useNavigation';
import criticasImg from '../assets/img/foto_grupo_4.png';

const CriticasSectionContainer = styled.section`
  display: flex;
  width: 100%;
  min-height: 100vh;

  @media (max-width: 900px) {
    flex-direction: column;
    min-height: unset;
  }
`;

const CriticasLeft = styled.div`
  flex: 1.1;
  background: #ba3b3b;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0eadd;
  padding: 0 4vw;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
    min-height: 50vh;
  }
`;

const CriticasContent = styled.div`
  max-width: 600px;
  width: 100%;

  @media (max-width: 900px) {
    max-width: 95vw;
    padding: 24px 0;
  }
`;

const CriticasTitle = styled.h2`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 80px;
  font-weight: bold;
  color: #f0eadd;
  line-height: 1;
  margin-bottom: 32px;

  @media (max-width: 1100px) {
    font-size: 48px;
  }
`;

const CriticasDescription = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 23.5px;
  color: #f0eadd;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 40px;

  @media (max-width: 1100px) {
    font-size: 16px;
  }
`;

const CriticasButton = styled.button`
  display: inline-block;
  background: #222;
  color: #f0eadd;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding: 16px 32px;
  border: 2px solid #f0eadd;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: #f0eadd;
    color: #222;
  }

  @media (max-width: 1100px) {
    font-size: 16px;
    padding: 14px 28px;
  }
`;

const CriticasRight = styled.div`
  flex: 1;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  background: #222;
  overflow: hidden;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
  }
`;

const CriticasImg = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    height: 40vh;
  }
`;

const CriticasSection = () => {
  const { navigateToCriticas } = useNavigation();

  const handleCriticasClick = () => {
    navigateToCriticas();
  };

  return (
    <CriticasSectionContainer>
      <CriticasLeft>
        <CriticasContent>
          <CriticasTitle>Nossas Críticas</CriticasTitle>
          <CriticasDescription>
            Descubra nossas análises detalhadas e opiniões sinceras sobre filmes, séries, livros e muito mais. 
            Cada crítica é escrita com paixão e honestidade, oferecendo uma perspectiva única sobre o mundo do entretenimento.
          </CriticasDescription>
          <CriticasButton onClick={handleCriticasClick}>
            Ver Críticas
          </CriticasButton>
        </CriticasContent>
      </CriticasLeft>
      <CriticasRight>
        <CriticasImg src={criticasImg} /> 
      </CriticasRight>
    </CriticasSectionContainer>
  );
};

export default CriticasSection;
